/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useParams } from 'react-router';
import PermitRegistrationDetailPageHOC from './PermitRegistrationDetailPageHOC';
import AlternatePermitHolder from '../components/registration/AlternatePermitHolder';
import EntryDateSelector from '../components/registration/EntryDateSelector';
import VehicleInformation from '../components/registration/VehicleInformation';
import GroupMemberList from '../components/registration/GroupMemberList';
import EmergencyContact from '../components/registration/EmergencyContact';
import TrailHeadSelector from '../components/registration/TrailHeadSelector';
import IssueStationDefault from '../components/registration/IssueStationDefault';
import IssueStationSelector from '../components/registration/IssueStationSelector';
import CommentBox from '../components/registration/CommentBox';
import MailingAddress from '../components/registration/MailingAddress';
import GroupDetailNew from '../components/registration/GroupDetailNew';
import PermitType from '../components/registration/PermitType';
import FlexFieldWrapper from '../components/registration/FlexFieldWrapper';
import {
    CLEAR_CREEK_PERMIT_ID,
    CAPE_HATTERAS_PERMIT_ID,
    FLORIDA_OHV_PERMIT_ID,
    CAPE_LOOKOUT_PERMIT_ID,
    ASSATEAGUE_PERMIT_ID,
    BIG_CYPRESS_PERMIT_ID,
    BIG_CYPRESS_LANDS_PERMIT_ID,
} from '../utils/utils';

const componentMapping = {
    [CLEAR_CREEK_PERMIT_ID]: [
        GroupDetailNew,
        AlternatePermitHolder,
        EntryDateSelector,
        VehicleInformation,
        IssueStationDefault,
        CommentBox,
    ],
    [CAPE_HATTERAS_PERMIT_ID]: [
        GroupDetailNew,
        EntryDateSelector,
        MailingAddress,
        VehicleInformation,
        IssueStationDefault,
        CommentBox,
    ],
    [CAPE_LOOKOUT_PERMIT_ID]: [
        GroupDetailNew,
        MailingAddress,
        PermitType,
        VehicleInformation,
        IssueStationDefault,
        CommentBox,
    ],
    [FLORIDA_OHV_PERMIT_ID]: [
        GroupDetailNew,
        EmergencyContact,
        TrailHeadSelector,
        EntryDateSelector,
        GroupMemberList(),
        VehicleInformation,
        IssueStationDefault,
        CommentBox,
    ],
    [ASSATEAGUE_PERMIT_ID]: [
        GroupDetailNew,
        PermitType,
        VehicleInformation,
        IssueStationSelector,
        CommentBox,
    ],
    [BIG_CYPRESS_PERMIT_ID]: [
        GroupDetailNew,
        PermitType,
        VehicleInformation,
        CommentBox,
        FlexFieldWrapper,
    ],
    [BIG_CYPRESS_LANDS_PERMIT_ID]: [
        GroupDetailNew,
        PermitType,
        VehicleInformation,
        CommentBox,
        FlexFieldWrapper,
    ],
};

export default function PermitRegistrationDetailPage() {
    const { permitId } = useParams();
    const compSet = componentMapping[permitId];
    const ChildComponent = PermitRegistrationDetailPageHOC(compSet);

    return <ChildComponent />;
}
